var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"misafirler"},_vm._l((_vm.misafirList),function(misafir,index){return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],key:index,attrs:{"variant":"light","title":misafir}},[_vm._v(_vm._s(misafir))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }